import { YodaBorderRadius, YodaColors, YodaFontSize } from 'yoda-ui/yodaTheme';

export const textYodaStyle = {
  '& label': {
    fontSize: YodaFontSize.medium,
    fontWeight: 300,
    lineHeight: '1rem',
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: YodaBorderRadius.small,
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: YodaColors.textSecondary,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: YodaColors.textSecondary,
    },
  },
  '& input': {
    fontSize: YodaFontSize.medium,
    '&::placeholder': {
      color: YodaColors.gray3,
      opacity: 0.8,
    },
  },
  '& textarea': {
    fontSize: YodaFontSize.medium,
    '&::placeholder': {
      fontSize: YodaFontSize.medium,
      color: YodaColors.gray3,
      opacity: 0.8,
    },
  },
  '& p.Mui-error': {
    margin: 0,
    fontWeight: 300,
  },
};

export const textYodaNoControlsStyle = {
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },

  '& input': {
    MozAppearance: 'textfield',
  },
};
